/* Exact-product preview. Native Shopify controls own variant and cart changes. */
(function () {
  'use strict';
  const chart = [
    {size:'S',cm:[46,71],in:[18,28]}, {size:'M',cm:[51,74],in:[20,29]},
    {size:'L',cm:[56,76],in:[22,30]}, {size:'XL',cm:[61,79],in:[24,31]},
    {size:'2XL',cm:[66,81],in:[26,32]}, {size:'3XL',cm:[71,84],in:[28,33]}
  ];
  const normal = value => String(value).toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  function matchingVariant(product, selections, size) {
    const position = product.options.findIndex(option => String(option.name || option).toLowerCase() === 'size');
    if (position < 0) return null;
    return product.variants.find(variant => product.options.every((_,i) =>
      i === position ? normal(variant.options[i]) === normal(size) : variant.options[i] === selections[i])) || null;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports={chart,normal,matchingVariant}; return; }
  const config=document.getElementById('gb-fit-config');
  const area=document.querySelector('[id^="ProductInfo-"]');
  const dialog=document.getElementById('gb-fit-dialog');
  if(!config || !area || !dialog || !dialog.showModal) return;
  const picker=()=>area.querySelector('variant-radios');
  const productData=()=>{try{return JSON.parse(document.getElementById('gb-fit-product-data').textContent);}catch{return null;}};
  if(!productData() || !picker()) return;
  let pending='', unit=config.dataset.defaultUnit, opener=null, busy=false, uncertain=false;
  const selected=()=>productData().options.map((_,i)=>picker()?.querySelector('[data-option-index="'+i+'"] input:checked')?.value);
  const variantFor=size=>matchingVariant(productData(),selected(),size);
  const currentSize=()=>{const p=productData();const i=p.options.findIndex(o=>String(o.name||o).toLowerCase()==='size');return normal(selected()[i]||'');};
  const q=selector=>dialog.querySelector(selector);
  function renderRows(){
    q('[data-fit-rows]').replaceChildren(...chart.map(row=>{
      const tr=document.createElement('tr');tr.classList.toggle('is-selected',normal(row.size)===normal(pending));
      const th=document.createElement('th');th.scope='row';th.textContent=row.size;tr.append(th);
      row[unit].forEach(value=>{const td=document.createElement('td');td.textContent=value+' '+unit;tr.append(td);});return tr;
    }));
    q('[data-fit-tolerance]').textContent=unit==='cm'?'Published chart tolerance: measurements may vary by 2.5–5 cm.':'Published chart tolerance: measurements may vary by 1–2 inches.';
  }
  function renderChoice(){
    renderRows();
    q('[data-fit-choices]').querySelectorAll('input').forEach(input=>{input.disabled=busy||!variantFor(input.value)?.available;});
    const v=variantFor(pending), valid=!!v?.available;
    q('[data-fit-apply]').disabled=!valid||busy||uncertain;
    q('[data-fit-apply]').textContent=busy?'Adding to cart…':uncertain?'Check your cart':valid?'Add size '+pending+' to cart':'Choose an available size';
    q('[data-fit-choice-note]').textContent=valid?'Size '+pending+' selected for comparison.':pending?'This size is unavailable for the selected colour.':'Choose a size to compare.';
  }
  function openGuide(trigger){
    opener=trigger;pending=currentSize();
    const p=productData();
    q('[data-fit-colour]').textContent=selected().filter((_,i)=>String(p.options[i].name||p.options[i]).toLowerCase()!=='size').join(' / ');
    q('[data-fit-choices]').replaceChildren(...chart.map(row=>{
      const label=document.createElement('label'), input=document.createElement('input'), text=document.createElement('span');
      input.type='radio';input.name='gb-fit-size';input.value=row.size;input.checked=row.size===pending;
      input.disabled=!variantFor(row.size)?.available;text.textContent=row.size;
      if(input.disabled){text.textContent+=' — unavailable';}
      input.addEventListener('change',()=>{pending=row.size;renderChoice();});label.append(input,text);return label;
    }));
    q('input[name="gb-fit-unit"][value="'+unit+'"]').checked=true;
    renderChoice();dialog.showModal();document.documentElement.classList.add('gb-fit-open');q('[data-fit-close]').focus();
  }
  function closeGuide(){if(!busy)dialog.close();}
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('gb-fit-open');if(opener?.isConnected)opener.focus();else area.querySelector('[data-gb-fit-open]')?.focus();});
  dialog.addEventListener('cancel',e=>{if(busy)e.preventDefault();});
  q('[data-fit-close]').addEventListener('click',closeGuide);
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeGuide();}});
  dialog.querySelectorAll('[name="gb-fit-unit"]').forEach(input=>input.addEventListener('change',()=>{unit=input.value;renderRows();}));
  q('[data-fit-apply]').addEventListener('click',()=>{
    const v=variantFor(pending);if(!v?.available||busy||uncertain)return;
    const p=productData(), position=p.options.findIndex(o=>String(o.name||o).toLowerCase()==='size');
    const control=Array.from(picker().querySelectorAll('[data-option-index="'+position+'"] input[type="radio"]')).find(el=>normal(el.value)===normal(pending));
    if(!control||control.disabled){q('[data-fit-choice-note]').textContent='Please close this guide and select your size on the product page.';return;}
    busy=true;renderChoice();control.click();
    const started=Date.now();
    function confirm(){
      const id=area.querySelector('product-form form input[name="id"]')?.value;
      if(id===String(v.id)&&currentSize()===normal(pending)&&!area.querySelector('product-form form')?.hasAttribute('aria-busy')){
        submitToCart(v);
      }else if(Date.now()-started>6000){busy=false;renderChoice();q('[data-fit-choice-note]').textContent='The size could not be confirmed. Close this guide and select it on the product page.';}
      else setTimeout(confirm,100);
    }confirm();
  });
  function submitToCart(variant){
    const form=area.querySelector('product-form form');
    const button=form?.querySelector('button[type="submit"]');
    if(!form||!button||button.disabled||button.getAttribute('aria-disabled')==='true'){busy=false;renderChoice();q('[data-fit-choice-note]').textContent='Unable to add this size. Please use Add to Cart on the product page.';return;}
    const formId=form.id;
    let timer;
    const cleanup=()=>{clearTimeout(timer);document.removeEventListener('gb:product-added',success,true);document.removeEventListener('rebuy:cart.add',rebuySuccess,true);document.removeEventListener('gb:product-error',failure,true);};
    const success=e=>{
      if(e.detail?.sourceId!==formId)return;
      cleanup();busy=false;renderChoice();dialog.close();
      const message=area.querySelector('[data-fit-confirm]');if(message)message.textContent='Size '+pending+' added to cart.';
    };
    const rebuySuccess=e=>{
      const item=e.detail?.item;
      const items=item?.items||[item];
      if(items.some(line=>Number(line?.variant_id||line?.id)===Number(variant.id)))success({detail:{sourceId:formId}});
    };
    const failure=e=>{
      if(e.detail?.sourceId!==formId||Number(e.detail?.variantId)!==Number(variant.id))return;
      cleanup();busy=false;renderChoice();q('[data-fit-choice-note]').textContent=e.detail.message||'This item could not be added. Please try again.';
    };
    document.addEventListener('gb:product-added',success,true);
    document.addEventListener('rebuy:cart.add',rebuySuccess,true);
    document.addEventListener('gb:product-error',failure,true);
    timer=setTimeout(()=>{cleanup();busy=false;uncertain=true;renderChoice();q('[data-fit-choice-note]').textContent='The cart response is delayed. Close this guide and check your cart before trying again.';},30000);
    try{form.requestSubmit(button);}catch(error){cleanup();busy=false;renderChoice();q('[data-fit-choice-note]').textContent='This item could not be added. Please use Add to Cart on the product page.';}
  }
  function mount(){
    const pk=picker();if(!pk)return;
    if(!area.querySelector('.gb-fit-summary')){
      const summary=document.createElement('div');summary.className='gb-fit-summary';
      summary.innerHTML='<div class="gb-fit-summary-title"><strong>Fit: slightly relaxed</strong></div><div class="gb-fit-scale" role="img" aria-label="Fit: slightly relaxed, same blank as Strike"><span>Fitted</span><span>Regular</span><span class="is-fit">Relaxed</span><span>Oversized</span></div><p>Compare with a tee you own to find your preferred fit.</p><a href="#" data-gb-fit-open aria-haspopup="dialog">Size & fit — compare measurements <span aria-hidden="true">↗</span></a><span class="visually-hidden" data-fit-confirm role="status" aria-live="polite"></span>';
      pk.after(summary);
    }
  }
  area.addEventListener('click',e=>{const trigger=e.target.closest('[data-gb-fit-open],a[href$="/pages/size-chart-new"]');if(trigger){e.preventDefault();openGuide(trigger);}});
  document.documentElement.classList.add('gb-fit-pilot');mount();
  const oldGuide=area.querySelector('a[href$="/pages/size-chart-new"]');
  if(oldGuide?.closest('p'))oldGuide.closest('p').hidden=true;
  const buy=area.querySelector('product-form')?.closest('.block');
  const summary=area.querySelector('.gb-fit-summary')?.closest('.block');
  if(buy&&summary&&buy.parentElement===summary.parentElement)summary.after(buy);
  area.querySelectorAll('details').forEach(details=>{if(['Size Chart','Sizing Information'].includes(details.querySelector('summary')?.textContent.trim()))details.hidden=true;});
})();
